<template>
  <v-footer color="green lighten-5" class="mt-8" padless>
    <v-row justify="center" no-gutters>
      <v-btn
        v-for="link in links"
        :key="link.name"
        :href="link.href"
        color="green"
        text
        class="my-2"
      >
        {{ link.name }}
      </v-btn>
      <v-col class="green lighten-5 py-4 text-center green--text" cols="12">
        <small>2020 — Vili Tikkanen</small>
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>
export default {
  name: 'GlobalFooter',
  data: () => ({
    links: [
      { name: 'Hallinta', href: 'https://hallinta.kotona.kiuruvesi.net' },
      { name: 'Ota yhteyttä / käyttöehdot', href: '/yhteys' },
      { name: 'Palvelimen tila', href: 'http://status.pysykotona.fi/' }
    ]
  })
}
</script>
